import { render } from "./ContentTreeNode.vue?vue&type=template&id=3bbbab8e&scoped=true"
import script from "./ContentTreeNode.vue?vue&type=script&lang=js"
export * from "./ContentTreeNode.vue?vue&type=script&lang=js"

import "./ContentTreeNode.vue?vue&type=style&index=0&id=3bbbab8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bbbab8e"]])

export default __exports__